'use strict';

var d3 = require('d3');

/**
 * Simple Bars
 *
 * Renders simple bars
 *
 * @returns {Function}
 * @constructor
 */
var SimpleBars = function SimpleBars() {
  /**
   * @param yPropertyName - a property name used to find Y value
   * @returns {Function}
   * @constructor
   */
  return function (yPropertyName) {
    var params, scales;
    var clearYPropertyName;
    function getValue(d) {
      return d[yPropertyName] || 0;
    }

    /**
     *
     * @param container
     */
    var bars = function bars(container) {
      var selector = yPropertyName + '-bar';
      var fillSelector = yPropertyName + 'fill';
      var barWidth = scales.xScale.rangeBand();
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        if (getValue(d) !== undefined) {
          if (clearYPropertyName) {
            d3.select(this).selectAll('.' + clearYPropertyName + '-bar').remove();
          }
          var simpleBars = d3.select(this).selectAll('.' + selector).data([d]);
          simpleBars.enter().append('rect');
          simpleBars.attr({
            'class': function _class(d) {
              return selector + ' simple-bar' + (getValue(d) < 0 ? ' negative-value' : '');
            },
            'y': function y(d) {
              var tempY = scales.yScale(Math.max(getValue(d), 0));
              var tempHeight = Math.abs(scales.yScale(0) - scales.yScale(getValue(d)));
              if (getValue(d) !== 0 && tempHeight === 0) {
                tempY = tempY - 1;
              }
              return tempY;
            },
            'width': barWidth,
            'height': function height(d) {
              var tempHeight = Math.abs(scales.yScale(0) - scales.yScale(getValue(d)));
              if (getValue(d) !== 0 && tempHeight === 0) {
                tempHeight = tempHeight + 1;
              }
              return tempHeight;
            }
          }).style({
            'fill': function fill(d) {
              if (d[fillSelector]) {
                return d[fillSelector];
              }
              if (!Array.isArray(d.fill)) {
                return d.fill;
              }
            }
          });
          if (params.isSparse) {
            simpleBars.attr({
              'x': function x() {
                return params.xBarPadding;
              },
              'width': function width() {
                return params.xDataSize - params.xBarPadding * 2;
              }
            });
          }
        }
      });
    };

    /**
     *  Setters and getters
     */

    bars.params = function (value) {
      params = value;
      return bars;
    };
    bars.scales = function (value) {
      scales = value;
      return bars;
    };
    bars.withYPropertyName = function (value) {
      if (clearYPropertyName !== value) {
        clearYPropertyName = yPropertyName;
      }
      yPropertyName = value;
      return bars;
    };
    return bars;
  };
};
SimpleBars.$inject = [];
module.exports = SimpleBars;